// src/components/layout/Footer.jsx
import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import { SparklesIcon } from '@heroicons/react/24/outline';

function Footer() {
    const currentYear = new Date().getFullYear();
    const [newsletterEmail, setNewsletterEmail] = useState('');
    const [isSubscribing, setIsSubscribing] = useState(false);
    const [subscriptionMessage, setSubscriptionMessage] = useState('');

    const handleNewsletterSubmit = async (e) => {
        e.preventDefault();
        if (!newsletterEmail) return;

        setIsSubscribing(true);
        setSubscriptionMessage('');

        try {
            const response = await fetch('/api/newsletter/subscribe', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: newsletterEmail, source: 'footer' })
            });

            const result = await response.json();
            setSubscriptionMessage(result.message);

            if (result.success) {
                setNewsletterEmail('');
            }
        } catch (error) {
            setSubscriptionMessage('Failed to subscribe. Please try again.');
        } finally {
            setIsSubscribing(false);
        }
    };

    const footerSections = [
        {
            title: 'Product',
            links: [
                { name: 'Features', href: '../#features' },
                { name: 'Pricing', href: '../#pricing' },
                // { name: 'API', href: '/api' },
                // { name: 'Integrations', href: '/integrations' },
            ]
        },
        {
            title: 'Company',
            links: [
                { name: 'About', href: '/about' },
                // { name: 'Blog', href: '/blog' },
                // { name: 'Careers', href: '/careers' },
                { name: 'Contact', href: '/contact' },
            ]
        },
        {
            title: 'Resources',
            links: [
                // { name: 'Documentation', href: '/docs' },
                // { name: 'Help Center', href: '/help' },
                // { name: 'Community', href: '/community' },
                { name: 'Status', href: '/status' },
            ]
        },

    ];

    const socialLinks = [
        {
            name: 'Twitter',
            href: 'https://twitter.com/postmgr',
            icon: (
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                </svg>
            )
        },
        {
            name: 'LinkedIn',
            href: 'https://linkedin.com/company/postmgr',
            icon: (
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
            )
        },
        {
            name: 'BlueSky',
            href: 'https://bsky.app/profile/postmgr.bsky.social',
            icon: (
                <svg className="h-7 w-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M4.66,1.28c2.46,1.85,5.11,5.62,6.08,7.63.97-2.02,3.62-5.78,6.08-7.63,1.78-1.34,4.66-2.37,4.66.92,0,.66-.38,5.53-.6,6.32-.77,2.75-3.56,3.45-6.05,3.03,4.34.74,5.45,3.2,3.06,5.65-4.53,4.67-6.51-1.17-7.02-2.67-.15-.43-.13-.44-.28,0-.51,1.5-2.49,7.33-7.02,2.67-2.39-2.46-1.28-4.91,3.06-5.65-2.49.42-5.28-.28-6.05-3.03-.22-.79-.6-5.66-.6-6.32C0-1.1,2.88-.06,4.66,1.28Z" />
                </svg>

            )
        },
        {
            name: 'Instagram',
            href: 'https://www.instagram.com/postmgrofficial/',
            icon: (
                <svg className="h-7 w-6" fill="currentColor" viewBox="0 0 24 24">
                    <path
                        d="M6.73,10.1c0-1.86,1.5-3.37,3.36-3.37,1.86,0,3.37,1.5,3.37,3.36,0,1.86-1.5,3.37-3.36,3.37-1.86,0-3.37-1.5-3.37-3.36ZM4.91,10.1c0,2.86,2.33,5.18,5.19,5.17,2.86,0,5.18-2.33,5.17-5.19,0-2.86-2.33-5.18-5.19-5.17-2.86,0-5.18,2.33-5.17,5.19h0ZM14.26,4.7c0,.67.54,1.21,1.21,1.21.67,0,1.21-.54,1.21-1.21,0-.67-.54-1.21-1.21-1.21-.67,0-1.21.54-1.21,1.21ZM6.03,18.32c-.98-.04-1.52-.21-1.87-.34-.47-.18-.81-.4-1.16-.75-.35-.35-.57-.69-.76-1.16-.14-.36-.3-.89-.35-1.87-.05-1.06-.06-1.38-.07-4.08,0-2.69,0-3.01.05-4.08.04-.98.21-1.52.34-1.87.18-.47.4-.81.75-1.16.35-.35.69-.57,1.16-.76.36-.14.89-.3,1.87-.35,1.06-.05,1.38-.06,4.08-.07,2.7,0,3.01,0,4.08.05.98.04,1.52.21,1.87.34.47.18.81.4,1.16.75.35.35.57.69.76,1.16.14.35.3.89.35,1.87.05,1.06.06,1.38.07,4.08,0,2.7,0,3.01-.05,4.08-.04.98-.21,1.52-.34,1.88-.18.47-.4.81-.75,1.16-.35.35-.69.57-1.16.76-.36.14-.89.3-1.87.35-1.06.05-1.38.06-4.08.07-2.69,0-3.01,0-4.08-.05h0ZM5.91.07c-1.07.05-1.81.22-2.45.47-.66.26-1.23.61-1.79,1.17-.56.56-.9,1.13-1.16,1.79-.25.64-.42,1.38-.46,2.45C0,7.03,0,7.37,0,10.11c0,2.74.02,3.08.07,4.16.05,1.07.22,1.81.47,2.45.26.66.61,1.23,1.17,1.79.56.56,1.13.9,1.79,1.16.64.25,1.38.42,2.45.46,1.08.05,1.42.06,4.16.05,2.74,0,3.09-.02,4.16-.07,1.07-.05,1.81-.22,2.45-.47.66-.26,1.23-.61,1.79-1.17.56-.56.9-1.13,1.16-1.79.25-.64.42-1.38.46-2.45.05-1.08.06-1.42.05-4.16,0-2.74-.02-3.08-.07-4.16-.05-1.07-.22-1.81-.47-2.45-.26-.66-.61-1.23-1.17-1.79-.56-.56-1.13-.9-1.79-1.16-.64-.25-1.38-.42-2.45-.46C13.16,0,12.82,0,10.07,0c-2.74,0-3.08.02-4.16.07h0Z"/>
                </svg>

            ),
        },
        {
            name: 'Facebook',
            href: 'https://www.facebook.com/profile.php?id=61578072236048',
            icon: (
                <svg className="h-7 w-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.88,10.44C20.88,4.67,16.21,0,10.44,0S0,4.67,0,10.44c0,4.9,3.37,9.01,7.92,10.13v-6.94h-2.15v-3.19h2.15v-1.37c0-3.55,1.61-5.2,5.1-5.2.66,0,1.8.13,2.27.26v2.89c-.25-.03-.67-.04-1.21-.04-1.71,0-2.37.65-2.37,2.33v1.13h3.41l-.59,3.19h-2.82v7.17c5.17-.62,9.18-5.03,9.18-10.37Z" />
                </svg>

            )
        }
    ];

    return (
        <footer className="bg-gray-900 text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                {/* Main footer content */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {/* Brand section */}
                    <div className="lg:col-span-1">
                        <div className="flex items-center">
                            <img src="/images/Bob_only.svg" alt="PostMgr" className="h-8 w-8" />
                            <span className="ml-2 text-xl font-bold">PostMgr</span>
                        </div>
                        <p className="mt-4 text-gray-400 text-sm">
                            AI-powered social media management that helps you create, schedule, and publish engaging content across all platforms.
                        </p>
                        <div className="mt-6 flex space-x-4">
                            {socialLinks.map((social) => (
                                <a
                                    key={social.name}
                                    href={social.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-gray-400 hover:text-white transition-colors"
                                    aria-label={social.name}
                                >
                                    {social.icon}
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Footer sections */}
                    {footerSections.map((section) => (
                        <div key={section.title}>
                            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
                                {section.title}
                            </h3>
                            <ul className="space-y-4s">
                                {section.links.map((link) => (
                                    <li key={link.name}>
                                        <Link
                                            to={link.href}
                                            className="text-gray-400 hover:text-white transition-colors text-sm"
                                        >
                                            {link.name}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                {/* Newsletter signup */}
                <div className="mt-12 pt-8 border-t border-gray-800">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                        <div>
                            <h3 className="text-lg font-semibold mb-2">Stay updated</h3>
                            <p className="text-gray-400 text-sm">
                                Get the latest updates on new features and social media best practices.
                            </p>
                        </div>

                            <form onSubmit={handleNewsletterSubmit} className="flex flex-col sm:flex-row gap-3">
                                <input
                                    type="email"
                                    placeholder="Enter your email"
                                    value={newsletterEmail}
                                    onChange={(e) => setNewsletterEmail(e.target.value)}
                                    className="flex-1 px-4 py-2 bg-gray-800 border border-gray-700 rounded-md text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    disabled={isSubscribing}
                                />
                                <button
                                    type="submit"
                                    disabled={isSubscribing || !newsletterEmail}
                                    className="px-6 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 text-white font-medium rounded-md transition-colors"
                                >
                                    {isSubscribing ? 'Subscribing...' : 'Subscribe'}
                                </button>
                            </form>
                            {subscriptionMessage && (
                                <p className={`text-sm mt-2 ${subscriptionMessage.includes('success') ? 'text-green-400' : 'text-red-400'}`}>
                                    {subscriptionMessage}
                                </p>
                            )}

                    </div>
                </div>

                {/* Bottom section */}
                <div className="mt-12 pt-8 border-t border-gray-800">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <div className="text-gray-400 text-sm">
                            © {currentYear} PostMgr. All rights reserved.
                        </div>
                        <div className="mt-4 md:mt-0 flex space-x-6">
                            <Link to="/eula" className="text-gray-400 hover:text-white text-sm transition-colors">
                                EULA
                            </Link>
                            <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors">
                                Privacy
                            </Link>
                            <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition-colors">
                                Terms
                            </Link>

                            <Link to="/cookie" className="text-gray-400 hover:text-white text-sm transition-colors">
                                Cookies
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;